const stringIsMarkdownForHyperlink = (string) => {
  const asString = String(string);
  const fullLinkOnlyRegex =
    /^\[([\w\s\d\(\)]+)\]\((https?:\/\/[\w\d./?=#-]+)\)$/;
  const fullLinkMatch = asString.match(fullLinkOnlyRegex);
  return fullLinkMatch;
};

export { stringIsMarkdownForHyperlink };
